import { VesselComparisonService } from './../../../../services/vessel-comparison/vessel-comparison.service';
import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { EsgIndicators } from "./tabs/esg-indicators";
import { MobileHelper } from "../../../../helpers/mobile-helper";
import { Claims } from "../../../../constants/authentication/claims";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { CreateVesselComparisonPdfRequest } from '../../../../models/vessel-comparison/vessel-comparison.models';
import { UserClientService } from '../../../../services/authentication/user-client.service';

class VesselComparisonTab {
    step: number;
    title: string;
    vm: any;
    model?: any;
    isVisible: boolean;
}
@autoinject()
@transient()
export class VesselComparison {

    public currentTab: VesselComparisonTab;
    tabs: VesselComparisonTab[];
    canGenerateVesselComparisonReport: boolean;

    constructor(protected bindingEngine: BindingEngine, private esgIndicator: EsgIndicators, //private dialogClientService: DialogClientService, 
        userClaimsService: UserClaimsService, private notificationClientService: NotificationClientService, private vesselComparisonService: VesselComparisonService,
        private userService: UserClientService) {
        this.canGenerateVesselComparisonReport = userClaimsService.hasPermission(Claims.CanGenerateVesselComparisonReport);
    }

    activate(params: any) {
        const vesselId = params && params.vesselId ? params.vesselId : null;
        this.setTabs(vesselId);
        this.navigateToTab(this.tabs[0]);

    }

    private setTabs(vesselId: number) {

        this.tabs = [
            {
                title: "ESG Indicators",
                step: 1,
                vm: this.esgIndicator,
                model: {
                    vesselId: vesselId,
                },
                isVisible: true
            }
        ];
    }

    generateReport() {

        if (this.canGenerateVesselComparisonReport && this.esgIndicator.enableGenerateReport) {

            const user = this.userService.currentUser;

            const request: CreateVesselComparisonPdfRequest = {
                vesselIds: this.esgIndicator.vesselOptionsVms.map(x => x.vesselId),
                userEmail: user.email
            }
            
            this.vesselComparisonService.createVesselComparisonPdf(request).then(() => {
                this.notificationClientService.show("Report generated.", "", NotificationType.Info);
            },  () => {
                this.notificationClientService.show("Failed to generate report.", "", NotificationType.Error);
            });
        }
        else { this.notificationClientService.show("Add a vessel in order to generate a report", "", NotificationType.Info); }
    }

    navigateToTab(tab: VesselComparisonTab) {
        this.currentTab = tab;
        this.scrollToTop();
    }

    scrollToTop() {
        const scrollElement = MobileHelper.getScrollParent(document.getElementsByClassName('page-vessel-comparison').item(0), false) as HTMLDivElement;

        setTimeout(() => {
            if (scrollElement) {
                scrollElement.scrollTop = 0;
            }
        });
    }
}
